import type { PersistentUnlockId, WeaponType } from '../types';

export interface PersistentUnlock {
  id: PersistentUnlockId;
  name: string;
  description: string;
  renownCost: number;
  /** Optional category for display grouping. */
  category: 'weapon' | 'apprentice' | 'cosmetic' | 'pool';
  /** If the unlock grants a weapon type, name it here. */
  grantsWeapon?: WeaponType;
}

export const PERSISTENT_UNLOCKS: PersistentUnlock[] = [
  {
    id: 'weapon_axe',
    name: 'Battle Axe Patterns',
    description: 'Heroes may now request axes. Axes have wide kill windows.',
    renownCost: 5,
    category: 'weapon',
    grantsWeapon: 'axe',
  },
  {
    id: 'weapon_spear',
    name: 'Spear Patterns',
    description: 'Heroes may now request spears. Spears are precise and deadly.',
    renownCost: 10,
    category: 'weapon',
    grantsWeapon: 'spear',
  },
  {
    id: 'apprentice_stoker',
    name: 'Apprentice Stoker',
    description: 'Permanent: heat decay is 15% slower.',
    renownCost: 8,
    category: 'apprentice',
  },
  {
    id: 'apprentice_carrier',
    name: 'Apprentice Carrier',
    description: 'Permanent: heroes pay 10% more for victories.',
    renownCost: 8,
    category: 'apprentice',
  },
  {
    id: 'apprentice_sharpener',
    name: 'Apprentice Sharpener',
    description: 'Permanent: forged weapons gain +5 base durability.',
    renownCost: 12,
    category: 'apprentice',
  },
  {
    id: 'hero_pool_expanded',
    name: 'Wider Renown',
    description: 'Doubles the variety of heroes who may visit your forge.',
    renownCost: 6,
    category: 'pool',
  },
  {
    id: 'memorial_wall',
    name: 'Memorial Wall',
    description: 'Heroes who die wielding your blades are remembered.',
    renownCost: 4,
    category: 'cosmetic',
  },
  {
    id: 'hall_of_fame_display',
    name: 'Hall of Fame Display',
    description: 'Weapons that survive 3+ battles earn a place of honor.',
    renownCost: 5,
    category: 'cosmetic',
  },
];
